import { Box } from "@mui/material";
import { CURRENT_VERSION } from "../../../../constants/version";
import { useLiveDateTime } from "../../../../utils/liveDateTime";

const Footer = () => {
  const { formattedDateTime } = useLiveDateTime();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "5px 20px 20px",
        fontSize: "16px",
        color: "#666",
        fontWeight: "600",
      }}
    >
      <Box>{formattedDateTime} </Box>
      <Box>{`V${CURRENT_VERSION}`} </Box>
    </Box>
  );
};

export default Footer;
